import { render, staticRenderFns } from "./NavigationUserMenu.vue?vue&type=template&id=255d49e2&"
import script from "./NavigationUserMenu.vue?vue&type=script&lang=js&"
export * from "./NavigationUserMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports